// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDGIK455aGkaT1bjAnagQn8tleuLiCH67Y",
  authDomain: "hot-setup-app.firebaseapp.com",
  projectId: "hot-setup-app",
  storageBucket: "hot-setup-app.firebasestorage.app",
  messagingSenderId: "328183185753",
  appId: "1:328183185753:web:5e088aea45797d0a0a8c48",
  measurementId: "G-ESPGZBMBFE"
};

const app = initializeApp(firebaseConfig);

export { app };

export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ cacheSizeBytes: 250 * 1024 * 1024 }) // 250MB cache for offline persistence
});

export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);